import React, { memo } from 'react'

import Text from './Text'
import PopoverHelpText from '../popoverHelpText/PopoverHelpText'

const HeadingWithHelpText = ({ label, helpText }) => {
  return (
    <Text
      variant='h4'
      label={
        <>
          {label} {helpText && <PopoverHelpText label={helpText} />}
        </>
      }
      fontWeight={800}
      sx={{ fontSize: '1.25rem' }}
    />
  )
}

export default memo(HeadingWithHelpText)
